import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiAlertTriangle, FiClock } = FiIcons;

const MemberAttentionBadge = ({ lastSession }) => {
  // Check if member needs attention (no sessions or last session > 30 days ago)
  const needsAttention = () => {
    if (!lastSession) return { needs: true, reason: 'No sessions recorded' };
    
    const lastSessionDate = new Date(lastSession);
    const thirtyDaysAgo = new Date();
    thirtyDaysAgo.setDate(thirtyDaysAgo.getDate() - 30);
    
    if (lastSessionDate < thirtyDaysAgo) {
      return { 
        needs: true, 
        reason: 'No sessions in 30+ days',
        daysAgo: Math.floor((new Date() - lastSessionDate) / (1000 * 60 * 60 * 24))
      };
    }
    
    return { needs: false };
  };

  const attentionStatus = needsAttention();
  
  if (!attentionStatus.needs) return null;
  
  return (
    <motion.div 
      initial={{ opacity: 0, scale: 0.8 }}
      animate={{ opacity: 1, scale: 1 }}
      className="inline-flex items-center px-2 py-1 rounded-md bg-red-50 border border-red-200 text-red-700 text-xs font-medium"
    >
      <SafeIcon icon={FiAlertTriangle} className="w-3 h-3 mr-1" />
      <span>
        {attentionStatus.reason}
        {attentionStatus.daysAgo && ` (${attentionStatus.daysAgo} days)`}
      </span>
    </motion.div>
  );
};

export default MemberAttentionBadge;